document.addEventListener("DOMContentLoaded", function() {
  // ========== COOKIE HELPER ==========
  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  // ========== MY RECOMMENDED PLAN / HAIR TEST VISIBILITY ==========
  var caseid = getCookie('case_id');
  var Synthetic_ID = getCookie('Synthetic_ID');
  var form_status = getCookie('form_status');
  var user = localStorage.getItem('user');

  if (caseid == null) {
    caseid = localStorage.getItem('caseId');
  }

  if (Synthetic_ID && form_status === 'filled') {
    var hairTestBtn = document.querySelector('.header-right-icons .header-btn.hair-test-btn');
    if (hairTestBtn) hairTestBtn.style.display = 'none';
    var headerMyResult = document.querySelector('.header-right-icons .myresult');
    if (headerMyResult) headerMyResult.classList.remove('d-none');
    var megaMyResult = document.getElementById('my-recommended-plan');
    if (megaMyResult) megaMyResult.style.display = '';
    var takeHairTestMenuSpan = document.querySelector('#take-hair-test a span');
    if (takeHairTestMenuSpan) {
      takeHairTestMenuSpan.innerHTML = 'Re-Take The Hair Test <sup>™</sup>';
    }
  } else {
    var callHairCoachItem = document.getElementById('call-hair-coach');
    if (callHairCoachItem) callHairCoachItem.style.display = 'none';
    var megaMyResultHide = document.getElementById('my-recommended-plan');
    if (megaMyResultHide) megaMyResultHide.style.display = 'none';
  }

  // ========== BOOK CALL BUTTON LOGIC ==========
  var bookCallHeaderBtn = document.getElementById('book-call-button-header');
  if (bookCallHeaderBtn) {
    bookCallHeaderBtn.style.display = 'none';
    if (Synthetic_ID && form_status === 'filled' && (user == undefined || user == null || user == '')) {
      bookCallHeaderBtn.style.display = 'flex';
      bookCallHeaderBtn.href = 'https://form.traya.health/pages/reschedule-slot/' + (caseid || Synthetic_ID);
      var callHairCoachVisible = document.getElementById('call-hair-coach');
      if (callHairCoachVisible) callHairCoachVisible.style.display = '';
    }
  }

  // ========== MENU NAVIGATION ==========
  var openBtn = document.querySelector('.js-mobile-nav-toggle');
  var megaMenu = document.getElementById('megaMenu');
  var closeBtn = document.getElementById('closeMegaMenu');
  var megaMenuPanel = document.getElementById('megaMenuPanel');
  var hairToggleBtn = document.getElementById('hairToggle');
  var hairDrawer = document.getElementById('hairDrawer');
  var scalpToggle = document.getElementById('scalpToggle');
  var scalpDrawer = document.getElementById('scalpDrawer');
  var openProductsBtn = document.getElementById('openAllProducts');
  var backProducts = document.getElementById('backFromProducts');
  var closeFromProducts = document.getElementById('closeFromProducts');
  var closeFromProductsDesktop = document.getElementById('closeFromProductsDesktop');
  var backProductsBreadcrumb = document.getElementById('backFromProductsBreadcrumb');
  var backFromScalp = document.getElementById('backFromScalp');
  var closeFromScalp = document.getElementById('closeFromScalp');
  var allProductsScreen = document.getElementById('allProductsScreen');
  var scalpOilScreen = document.getElementById('scalpOilScreen');
  var scalpInner = scalpOilScreen ? scalpOilScreen.querySelector('.scalp-inner') : null;

  // --- Navigation helpers ---
  function showMainMenu() {
    allProductsScreen.classList.remove('active');
    if (scalpOilScreen.classList.contains('active')) {
      closeScalpOil();
    }
  }

  function showAllProducts() {
    if (scalpOilScreen.classList.contains('active')) {
      closeScalpOil();
    }
    allProductsScreen.classList.add('active');
  }

  function showScalpOil() {
    allProductsScreen.classList.remove('active');
    megaMenuPanel.style.display = 'none';
    scalpOilScreen.classList.add('active');
  }

  function closeScalpOil() {
    scalpOilScreen.classList.remove('active');
    megaMenuPanel.style.display = '';
    allProductsScreen.classList.add('active');
  }

  function closeMegaMenu() {
    allProductsScreen.classList.remove('active');
    scalpOilScreen.classList.remove('active');
    megaMenuPanel.style.display = '';
    megaMenu.classList.remove('active');
    document.body.style.overflow = '';
  }

  // --- Open ---
  if (openBtn) {
    openBtn.addEventListener('click', function() {
      if (typeof gtag === 'function') {
        var cst = null;
        try { cst = JSON.parse(localStorage.getItem('CstData')); } catch (e) {}
        var ua = (cst && cst.User_Analysis) || {};
        gtag('event', 'hamburger_clicked', {
          send_to: 'G-KJK84KP0LJ',
          url: window.location.href,
          page_url: window.location.href,
          fingerprintID: window.__deviceId || localStorage.getItem('deviceId') || '',
          user_type: window.trayaUserType || (localStorage.getItem('user') ? 'customer' : (getCookie('form_status') === 'filled' ? 'lead' : (cst || Synthetic_ID ? 'draft' : 'new_user'))),
          hostname: window.location.hostname,
          referrer: document.referrer,
          screen: window.screen.width + 'x' + window.screen.height,
          case_id: ua.case_id || caseid || '',
          synthetic_id: Synthetic_ID || '',
          title: document.title
        });
      }
      megaMenu.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }

  // --- Close buttons ---
  if (closeBtn) closeBtn.addEventListener('click', closeMegaMenu);
  if (closeFromProducts) closeFromProducts.addEventListener('click', closeMegaMenu);
  if (closeFromProductsDesktop) closeFromProductsDesktop.addEventListener('click', closeMegaMenu);
  if (closeFromScalp) closeFromScalp.addEventListener('click', closeMegaMenu);

  // --- Click on dark overlay to close ---
  if (megaMenu) {
    megaMenu.addEventListener('click', function(e) {
      if (e.target === megaMenu) {
        closeMegaMenu();
      }
    });
  }

  // --- All Products ---
  if (openProductsBtn) {
    openProductsBtn.addEventListener('click', showAllProducts);
  }

  // --- Back from All Products ---
  if (backProducts) {
    backProducts.addEventListener('click', showMainMenu);
  }
  if (backProductsBreadcrumb) {
    backProductsBreadcrumb.addEventListener('click', showMainMenu);
  }

  // --- Back from Scalp Oil ---
  if (backFromScalp) {
    backFromScalp.addEventListener('click', function() {
      closeScalpOil();
    });
  }

  // --- Hair Science accordion ---
  if (hairToggleBtn) {
    hairToggleBtn.addEventListener('click', function() {
      hairDrawer.classList.toggle('open');
      hairToggleBtn.querySelector('.arrow').classList.toggle('active-arrow');
      hairToggleBtn.classList.toggle('active');
    });
  }

  // --- Scalp Oil toggle ---
  if (scalpToggle) {
    scalpToggle.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.innerWidth <= 768) {
        scalpDrawer.classList.toggle('open');
        var arrow = scalpToggle.querySelector('.scalp-arrow');
        if (arrow) {
          arrow.style.transform = scalpDrawer.classList.contains('open') ? 'rotate(90deg)' : '';
        }
      } else {
        showScalpOil();
      }
    });
  }

  // ========== GOOGLE ANALYTICS EVENT TRACKING (DEDUPLICATED) ==========
  if (window._gaEventsInitialized) return;
  window._gaEventsInitialized = true;

  var CTA_POSITION = 'header-mega-menu';
  var _lastEvent = {};

  function sendGAEvent(eventName, params) {
    try {
      var key = eventName + JSON.stringify(params);
      var now = Date.now();
      if (_lastEvent[key] && (now - _lastEvent[key]) < 1000) return;
      _lastEvent[key] = now;
      if (typeof gtag === 'function') {
        gtag('event', eventName, Object.assign({ send_to: 'G-KJK84KP0LJ' }, params));
      }
    } catch (e) {
      console.log('GA Error:', e);
    }
  }

  function trackClick(id, eventName, params) {
    var el = document.getElementById(id);
    if (el) {
      el.addEventListener('click', function(e) {
        e.stopPropagation();
        sendGAEvent(eventName, params);
      });
    }
  }

  // --- Download App Banner ---
  trackClick('download-app-banner', 'download_app_clicked', { cta_label: 'Download App Banner', cta_position: CTA_POSITION });

  // --- Download App (Desktop/Mobile with store detection) ---
  ['download-app-desktop', 'download-app-mobile'].forEach(function(id) {
    var container = document.getElementById(id);
    if (container) {
      container.addEventListener('click', function(e) {
        e.stopPropagation();
        var storeBtn = e.target.closest('#google-play-btn, #app-store-btn, #google-play-btn-mobile, #app-store-btn-mobile');
        if (storeBtn) {
          sendGAEvent('download_app_clicked', {
            cta_label: storeBtn.id.indexOf('google') > -1 ? 'Google Play' : 'App Store',
            cta_position: CTA_POSITION
          });
        } else {
          sendGAEvent('download_app_clicked', { cta_label: 'Download App', cta_position: CTA_POSITION });
        }
      });
    }
  });

  // --- Take / Re-Take Hair Test ---
  var takeHairTestEl = document.getElementById('take-hair-test');
  if (takeHairTestEl) {
    takeHairTestEl.addEventListener('click', function(e) {
      e.stopPropagation();
      var spanText = takeHairTestEl.querySelector('a span');
      var isRetake = spanText && spanText.textContent.indexOf('Re-Take') > -1;
      sendGAEvent(isRetake ? 'Re-Take The Hair Test' : 'hair_test_cta_clicked', {
        cta_label: isRetake ? 'Re-Take The Hair Test' : 'Take The Hair Test',
        cta_position: CTA_POSITION
      });
    });
  }

  // --- My Recommended Plan ---
  trackClick('my-recommended-plan', 'recommended_plan_clicked', { cta_label: 'My Recommended Plan', cta_position: CTA_POSITION });

  // --- Call Hair Coach ---
  trackClick('call-hair-coach', 'call_hair_coach_click', { cta_label: 'Call Hair Coach', cta_position: CTA_POSITION });

  // --- WhatsApp ---
  trackClick('chat-whatsapp', 'Whatsapp_Clicked', { cta_label: 'Chat on WhatsApp', cta_position: CTA_POSITION });

  // --- Support Email ---
  trackClick('support-email', 'support_email_click', { cta_label: 'Support Email', cta_position: CTA_POSITION });
  
  // --- Support phone ---
  trackClick('support-phone', 'support_IVR_click', { cta_label: 'Support Phone', cta_position: CTA_POSITION });

  // --- Hair Science ---
  trackClick('hairToggle', 'navigation_click', { cta_label: 'Hair Science', cta_position: CTA_POSITION });
   
trackClick('traya_combo_click', 'traya_combo_click', { cta_label: 'Traya Combos', cta_position: CTA_POSITION });

trackClick('js-mobile-nav-toggle', 'humburgerMenu_clicked', { cta_label: 'Hamburger menu', cta_position: CTA_POSITION });

  // --- Navigation Links ---
  trackClick('customer-stories', 'navigation_click', { cta_label: 'Customer Stories', cta_position: CTA_POSITION });
  trackClick('blogs', 'navigation_click', { cta_label: 'Blogs', cta_position: CTA_POSITION });
  trackClick('our-story', 'navigation_click', { cta_label: 'Our Story', cta_position: CTA_POSITION });
  trackClick('money-back-policy', 'navigation_click', { cta_label: 'Money Back Policy', cta_position: CTA_POSITION });
  trackClick('return-policy', 'navigation_click', { cta_label: 'Return Policy', cta_position: CTA_POSITION });
  trackClick('openAllProducts', 'navigation_click', { cta_label: 'All Products', cta_position: CTA_POSITION });
  

  // --- Social Icons ---
  var socialIcons = {
    'social-youtube': 'YouTube',
    'social-instagram': 'Instagram',
    'social-facebook': 'Facebook',
    'social-whatsapp': 'WhatsApp'
  };

  Object.keys(socialIcons).forEach(function(id) {
    trackClick(id, 'social_icon_clicked', { icon_clicked: socialIcons[id], cta_position: CTA_POSITION });
  });
});

// ========== UTM PARAMETER PASSING FOR HAIR TEST CTA ==========
(function() {
  var hairTestCtaButtons = document.querySelectorAll('.mega-menu-section .firstload-hairtest-cta, .mega-menu-section .assessment-btn-menu');
  var baseUrl = "https://form.traya.health/questions?cohort=1&location=header-mega-menu&page=";
  var currentUrl = window.location.href;
  var pageName = "home";
  var searchParams = window.location.search ? '&' + window.location.search.substring(1) : '';

  var pageMappings = [
    { keyword: "pages/tamil", name: "tamil" },
    { keyword: "pages/gujarat", name: "gujarat" },
    { keyword: "pages/home-lp", name: "home-lp" },
    { keyword: "pages/hair-quiz", name: "hair-quiz" },
    { keyword: "pages/root-cause-of-hair-loss", name: "diagnosis" },
    { keyword: "pages/reviews", name: "traya-review" },
    { keyword: "pages/hair-coach", name: "hair-coach" },
    { keyword: "pages/10-lakh-indians", name: "10-lakh-indians" },
    { keyword: "pages/traya-vs-transplant", name: "traya-vs-transplant" },
    { keyword: "pages/trust-stories", name: "trust-stories" },
    { keyword: "pages/dandruff-root-cause", name: "dandruff-root-cause" },
    { keyword: "pages/clinical-study-1", name: "clinical-study-1" },
    { keyword: "pages/hindi", name: "hindi" },
    { keyword: "pages/telugu-1", name: "telugu-1" }
  ];

  if (currentUrl === "https://traya.health/") {
    pageName = "home";
  } else if (currentUrl.indexOf("/blog") > -1) {
    pageName = window.location.pathname.replace(/^\/|\/$/g, '').replace(/\//g, '_');
  } else if (currentUrl.indexOf("pages/traya-clinic") > -1) {
    pageName = window.location.pathname.replace(/^\/|\/$/g, '').replace(/^pages\//, '');
  } else {
    for (var i = 0; i < pageMappings.length; i++) {
      if (currentUrl.indexOf(pageMappings[i].keyword) > -1) {
        pageName = pageMappings[i].name;
        break;
      }
    }
  }

  var finalUrl = baseUrl + pageName + searchParams;

  for (var j = 0; j < hairTestCtaButtons.length; j++) {
    (function(button) {
      button.addEventListener('click', function() {
        button.setAttribute('href', finalUrl);
      });
    })(hairTestCtaButtons[j]);
  }
})();


// ========== HEADER SCROLL EFFECT ==========
var customHeader = document.querySelector('.template-index .custom-header');

function handleHeaderScroll() {
  if (window.scrollY > 10) {
    customHeader.style.background = 'var(--neutralgrey-700, #404040)';
    customHeader.style.boxShadow = '0 2px 4px 0 rgba(0, 0, 0, 0.08)';
  } else {
    customHeader.style.background = 'transparent';
    customHeader.style.boxShadow = 'none';
  }
}

if (customHeader) {
  handleHeaderScroll();
  window.addEventListener('scroll', handleHeaderScroll);
}

// ================================================================
// LOGGED-IN ACCOUNT MENU (homepage only)
// For logged-in non-customers (lead / draft), swap the hamburger for an
// account icon and reveal a profile header + Logout in the mega menu.
// Customers are redirected off the homepage elsewhere, so they never
// reach this state.
// ================================================================
(function () {
  // Homepage only — the requirement is scoped to the homepage, and the
  // account icon's white stroke is designed for the banner's dark header.
  if (window.location.pathname !== '/') return;

  // Display name — set as the `first_name` cookie by the formv2s login app.
  var NAME_COOKIE = 'first_name';

  function getCookie(name) {
    var v = '; ' + document.cookie;
    var p = v.split('; ' + name + '=');
    if (p.length === 2) return decodeURIComponent(p.pop().split(';').shift());
    return '';
  }

  // ---- Logged-in detection ----
  // formv2s sets the `is_logged_in` cookie on successful login. A customer
  // (ordered user) is excluded — their homepage must not change.
  var isLoggedIn = getCookie('is_logged_in');
  var isCustomer = !!localStorage.getItem('user');

  if (!isLoggedIn || isLoggedIn === 'false' || isLoggedIn === '0' || isCustomer) return;

  var wrapper = document.querySelector('.mega-menu-section');
  if (!wrapper) return;

  // ---- Profile name + avatar ----
  var rawName = getCookie(NAME_COOKIE).trim();

  // Deterministic avatar color from the name (stable per user, not re-randomized).
  var PALETTE = ['#2D8A5D', '#C06C3E', '#3E6BC0', '#8A5DB0', '#B0415D', '#1F8A8A', '#946A00'];
  function colorFor(s) { return PALETTE[(s.charCodeAt(0) || 0) % PALETTE.length]; }

  var nameEl   = document.getElementById('megaProfileName');
  var avatarEl = document.getElementById('megaProfileAvatar');

  if (rawName) {
    var initial = rawName.charAt(0);
    var bg = colorFor(rawName);
    if (nameEl) nameEl.textContent = rawName;
    if (avatarEl) { avatarEl.textContent = initial; avatarEl.style.background = bg; }
  }
  // No name → keep the gray avatar SVG + "User Account" default.

  wrapper.classList.add('is-logged-in');

  // ---- Logout: clear the current-flow state, then reload the homepage ----
  // Wiping the case/synthetic identifiers reverts the homepage to the
  // logged-out (new_user) experience — "back to the existing experience".
  var CLEAR_COOKIES = ['is_logged_in', 'case_id', 'Synthetic_ID', 'syntheticId', 'form_status', 'gender', 'user_phone', 'pathName', 'partnerUser', NAME_COOKIE];
  var CLEAR_LS      = ['caseId', 'user', 'CstData', 'rid', 'user-gender', 'user_syncId', 'form_fill_date', 'traya_path_name'];

  var logoutBtn = document.getElementById('megaLogoutBtn');
  if (logoutBtn) {
    logoutBtn.addEventListener('click', function () {
      CLEAR_COOKIES.forEach(function (c) {
        document.cookie = c + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        document.cookie = c + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.traya.health';
      });
      CLEAR_LS.forEach(function (k) { localStorage.removeItem(k); });
      window.location.href = '/';
    });
  }
})();